var _defs, _rect, _path, _rect2, _path2, _rect3, _rect4, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lease",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 221.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#888;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 16.34,
    width: 96.29,
    height: 193.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,34.58v207.9H81.72V223.92H96.29V34.58ZM38.16,212.26H12.68V187.35H38.16Zm0-43.29H12.68V144.06H38.16Zm0-43.12H12.68V100.94H38.16Zm0-43.12H12.68V57.82H38.16ZM85.9,212.26H60.42V187.35H85.9Zm0-43.29H60.42V144.06H85.9Zm0-43.12H60.42V100.94H85.9Zm0-43.12H60.42V57.82H85.9Z",
    transform: "translate(0 -32.95)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 181.07,
    y: 11.53,
    width: 102.54,
    height: 190.52
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.08,224.88V33H179.22V224.88H166.07v17.6H300v-17.6Zm-39.31,6.38H218.31v-24h29.46ZM275.52,196h-87V185.8h87Zm0-18.11h-87v-10.2h87Zm0-18.11h-87v-10.2h87Zm0-18.12h-87V131.46h87Zm0-18.11h-87v-10.2h87Zm0-18.11h-87V95.23h87Zm0-18.12h-87V77.12h87Zm0-18.11h-87V59h87Z",
    transform: "translate(0 -32.95)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.4,
    y: 21.14,
    width: 137.33,
    height: 199.87
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 66.4,
    y: 20.24,
    width: 137.33,
    height: 17.14
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.4,76.2V254h62.41V228.19h14.95V254h60V76.2ZM99.31,96.5h11.16v17.59H99.31Zm0,24.59h11.16v17.59H99.31Zm0,24.59h11.16v17.6H99.31Zm0,24.59h11.16v17.59H99.31Zm0,24.59h11.16v17.59H99.31ZM81.22,96.5H92.38v17.59H81.22Zm0,24.59H92.38v17.59H81.22Zm0,24.59H92.38v17.6H81.22Zm0,24.59H92.38v17.59H81.22Zm0,24.59H92.38v17.59H81.22Zm33.54,44.66H90.28v-6.31h24.48Zm12.45-27.07H116.05V194.86h11.16Zm0-24.59H116.05V170.27h11.16Zm0-24.58H116.05v-17.6h11.16Zm0-24.6H116.05V121.09h11.16Zm0-24.59H116.05V96.5h11.16ZM159.34,96.5H170.5v17.59H159.34Zm0,24.59H170.5v17.59H159.34Zm0,24.59H170.5v17.6H159.34Zm0,24.59H170.5v17.59H159.34Zm0,24.59H170.5v17.59H159.34Zm-6.54,17.59H141.64V194.86H152.8Zm0-24.59H141.64V170.27H152.8Zm0-24.58H141.64v-17.6H152.8Zm0-24.6H141.64V121.09H152.8Zm0-24.59H141.64V96.5H152.8Zm25,125.43H153.28v-6.31h24.48Zm11.16-27.07H177.76V194.86h11.16Zm0-24.59H177.76V170.27h11.16Zm0-24.58H177.76v-17.6h11.16Zm0-24.6H177.76V121.09h11.16Zm0-24.59H177.76V96.5h11.16Z",
    transform: "translate(0 -32.95)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLease);
export default __webpack_public_path__ + "static/media/lease.0d355b1912f005b2e5822d56045ddbe5.svg";
export { ForwardRef as ReactComponent };